import {type ActionTree} from 'vuex';

const updateInterval = 300;

const actions: ActionTree<ModuleNewsState, RootState> = {
    fetch({commit, state})
    {
        if (state.lastUpdate !== 0 && Date.now() - state.lastUpdate < updateInterval * 1000)
        {
            return;
        }

        return this.dispatch('getPage', {'url': '/news/fetch-data'}).then(({data: {data}}) =>
        {
            data.lastUpdate = Date.now();
            commit('update', data);
        });
    },
};

export default actions;